var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7705 11.7953H3.53906M18.8729 3.30273V7.07721M9.43669 3.30273V7.07721M9.20078 25.9496H19.1088C21.0906 25.9496 22.0815 25.9496 22.8384 25.5639C23.5042 25.2247 24.0456 24.6833 24.3848 24.0175C24.7705 23.2606 24.7705 22.2697 24.7705 20.2879V10.3799C24.7705 8.39809 24.7705 7.4072 24.3848 6.65026C24.0456 5.98443 23.5042 5.4431 22.8384 5.10385C22.0815 4.71816 21.0906 4.71816 19.1088 4.71816H9.20078C7.21899 4.71816 6.2281 4.71816 5.47116 5.10385C4.80533 5.4431 4.264 5.98443 3.92474 6.65026C3.53906 7.4072 3.53906 8.3981 3.53906 10.3799V20.2879C3.53906 22.2697 3.53906 23.2606 3.92474 24.0175C4.264 24.6833 4.80533 25.2247 5.47116 25.5639C6.2281 25.9496 7.21899 25.9496 9.20078 25.9496Z",
    stroke: "white",
    strokeWidth: 1.88724,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDate);
export default __webpack_public_path__ + "static/media/calendar-date.ab237296622e1feb9b234d3977030eea.svg";
export { ForwardRef as ReactComponent };